import './PrimeInputPassword.scss';
import { forwardRef } from "react";
import { Password } from 'primereact/password';

const PrimeInputPassword = forwardRef((props, ref) => {
  const { className, isTypeInset, leftIcon,...restProps } = props
  const insetTypeClassName = isTypeInset ? 'InsetType' : ''

  const passwordField = <Password toggleMask ref={ref} className={`PrimeInputPassword ${insetTypeClassName} ${className}`} {...restProps} />
  
  if (leftIcon) {
    return (
      <div className='relative PrimeInputPasswordLeftIconContainer'>
        <span className='absolute z-1'>
          {leftIcon}
        </span>
        {passwordField}
      </div>
    )
  }
  return passwordField
})

PrimeInputPassword.defaultProps = {
  isTypeInset: false
}

export default PrimeInputPassword